import { axios, Response } from '../index'

const deleteOperatorById = (operatorId: string): Response<null> => {
  return axios.delete(`/v1/operators/${operatorId}`)
}

export default deleteOperatorById
